import { PointRanking } from './PointRanking';

/**
 * Class representing a user point ranking.
 * @extends PointRanking
 */
export class UserPointRanking extends PointRanking {}
